export const SEND_DNS_CONFIGURATIONS_START = 'SEND_DNS_CONFIGURATIONS_START';
export const SEND_DNS_CONFIGURATIONS_SUCCESS = 'SEND_DNS_CONFIGURATIONS_SUCCESS';
export const SEND_DNS_CONFIGURATIONS_FAILED = 'SEND_DNS_CONFIGURATIONS_FAILED';
export const VERIFY_DNS_CONFIGURATIONS_START = 'VERIFY_DNS_CONFIGURATIONS_START';
export const VERIFY_DNS_CONFIGURATIONS_SUCCESS = 'VERIFY_DNS_CONFIGURATIONS_SUCCESS';
export const VERIFY_DNS_CONFIGURATIONS_FAILED = 'VERIFY_DNS_CONFIGURATIONS_FAILED';

export const sendDNSConfigurationsStart = () => ({
  type: SEND_DNS_CONFIGURATIONS_START
});

export const sendDNSConfigurationsSuccess = (data) => ({
  type: SEND_DNS_CONFIGURATIONS_SUCCESS,
  data
});

export const sendDNSConfigurationsFailed = (error) => ({
  type: SEND_DNS_CONFIGURATIONS_FAILED,
  error
});

export const verifyDNSConfigurationsStart = () => ({
  type: VERIFY_DNS_CONFIGURATIONS_START
});

export const verifyDNSConfigurationsSuccess = (data) => ({
  type: VERIFY_DNS_CONFIGURATIONS_SUCCESS,
  data
});

export const verifyDNSConfigurationsFailed = (error) => ({
  type: VERIFY_DNS_CONFIGURATIONS_FAILED,
  error
});
